import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { PipesModule } from '@nx-fe/pipes';
import { SharedComponentsModule } from 'app/shared/shared-components.module';
import { DeviceInfoComponent } from './device-info.component';

@NgModule({
    declarations: [DeviceInfoComponent],
    imports: [CommonModule, SharedComponentsModule, MatTooltipModule, PipesModule],
    exports: [DeviceInfoComponent]
})
export class DeviceInfoModule {}
